import { useQuery } from "@tanstack/react-query"

import { getClientQuestionnaire } from "./api"
import { QueryKey } from "../../types/queries"

export const useQuestionnaireQuery = (userId: number) => {
  return useQuery({
    queryKey: [QueryKey.CLIENT_QUESTIONNAIRES, userId],
    queryFn: () => getClientQuestionnaire(userId),
    enabled: !!userId,
  })
}
